import { render, staticRenderFns } from "./TransactionsView.vue?vue&type=template&id=2e93b3a3&scoped=true&"
import script from "./TransactionsView.vue?vue&type=script&lang=ts&"
export * from "./TransactionsView.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionsView.vue?vue&type=style&index=0&id=2e93b3a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e93b3a3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VSwitch,VTooltip})
